export default __webpack_public_path__ + "static/media/4444.bd939166.JPG";